<script setup lang="ts">
  import type { NuxtError } from 'nuxt/app';

  const props = defineProps<{ error: NuxtError }>();

  const showButton = computed(() => (props.error.data as any)?.showButton);

  const runtimeConfig = useRuntimeConfig();
  const errorMsgList: any = {};

  runtimeConfig.public.serverErrorMsg.split('|').forEach((i) => {
    const parts = i.split(':');
    if (parts.length < 2) return;
    errorMsgList[parts[0]] = parts[1];
  });

  const { locale } = useI18n();
  const backRoute = `/${locale.value}`;
</script>

<template>
  <div class="error-page">
    <h1>{{ error.statusCode }}</h1>
    <p>{{ errorMsgList[locale] ?? '' }}</p>
    <NuxtLink
      v-if="showButton"
      style="padding-left: 5rem; padding-right: 5rem; font-weight: 800"
      :to="backRoute">
      &larr;
    </NuxtLink>
  </div>
</template>
